import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export function setOpenPositionPermissions(user: User, builder: AbilityBuilder<AppAbility>): void {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.MasterdataAdministrator)) {
    can(Action.Manage, "OpenPosition");
    can(Action.Manage, "OpenPositionDunningBlock");
    return;
  }

  if (user.roles.includes(SubjectRoles.FiaUser)) {
    can(Action.Read, "OpenPosition");
    can(Action.Manage, "OpenPositionDunningBlock");
  }
}
